import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import axios from "axios";
import Loading from "../loading/loading";
import "./invoice.css";

const Invoice = () => {
  const { id } = useParams();
  const [request, setRequest] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchRequest = async () => {
      try {
        const userOP = JSON.parse(localStorage.getItem("userOP"));
        let response;

        if (id && id.toString().startsWith("AI-")) {
          const numericId = id.toString().replace("AI-", "");
          response = await axios.get(
            `https://py.qubx3d.com/api/v1/ai-segmentation/requests/${numericId}/`,
            {
              headers: {
                Authorization: `Bearer ${userOP.access}`,
              },
            },
          );

          if (response.data) {
            const aiReq = response.data;
            // Transform AI request to match structure used in the invoice
            const transformed = {
              ...aiReq,
              id: id,
              patient: {
                fullname:
                  aiReq.patient_name || aiReq.patient?.fullname || "AI Patient",
                mobile: aiReq.patient_phone || aiReq.patient?.mobile || "",
              },
              doctor: {
                fullname:
                  aiReq.doctor_name || aiReq.doctor?.fullname || "AI Doctor",
              },
              service: {
                name: "AI Segmentation",
                type: { name: "AI Segmentation", id: 4 },
              },
              // Ensure numeric fields
              price: parseFloat(aiReq.price || 0),
              special_discount: parseFloat(aiReq.special_discount || 0),
              remaining_amount: parseFloat(aiReq.remaining_amount || 0),
              paid_amount: parseFloat(aiReq.paid_amount || 0),
            };
            setRequest(transformed);
          }
        } else {
          response = await axios.get(
            `https://py.qubx3d.com/api/v1/request?id=${id}`,
            {
              headers: {
                Authorization: `Bearer ${userOP.access}`,
              },
            },
          );
          if (response.data.results && response.data.results.length > 0) {
            const rawReq = response.data.results[0];
            setRequest({
              ...rawReq,
              // Normalize branchName from multiple possible API fields
              branchName:
                rawReq.branchName ||
                rawReq.created_by?.branch_profile?.name ||
                rawReq.branch?.name ||
                "",
            });
          }
        }
      } catch (error) {
        console.error("Error fetching request details:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchRequest();
  }, [id]);

  const handlePrint = () => {
    window.print();
  };

  if (loading) return <Loading />;
  if (!request)
    return <div className="text-center mt-5">Request not found</div>;

  const totalAmount = request.price || 0;
  const discount = Math.abs(request.special_discount || 0);
  const finalAmount = totalAmount - discount;
  const safePaidAmount = request.paid_amount
    ? parseFloat(String(request.paid_amount).replace(/[$,]/g, ""))
    : 0;

  const currency = request.service?.type?.name === "3D Printing" ? "EGP" : "$";

  // Portal branch → Bill to patient; other branches → Bill to doctor
  const isPortalBranch = request.branchName?.toLowerCase().includes("portal");

  return (
    <div className="invoice-wrapper">
      <div
        className="invoice-container shadow-sm p-5 bg-white rounded"
        id="printable-invoice"
      >
        {/* Header */}
        <div className="invoice-header d-flex justify-content-between align-items-center mb-5">
          <div className="logo-section">
            <img
              src="/images/header/logo-black.png"
              alt="QUBX Logo"
              className="invoice-logo"
            />
            {/* <h2 className="brand-name mt-2">QUBX 3D</h2> */}
          </div>
          <div className="invoice-status-section text-end">
            <h1 className="invoice-title">INVOICE</h1>
            <p className="invoice-id">#ID: {request.id}</p>
            <p className="invoice-date">
              Date: {new Date(request.created_at).toLocaleDateString()}
            </p>
          </div>
        </div>

        <hr className="divider" />

        {/* Client & Patient Info */}
        <div className="row mb-5">
          <div className="col-6">
            <h5 className="section-title">BILL TO</h5>
            <div className="info-box">
              {isPortalBranch ? (
                <p>
                  <strong>Dr:</strong> {request.doctor?.fullname || "N/A"}
                </p>
              ) : (
                <p>
                  <strong>Patient:</strong> {request.patient?.fullname}
                </p>
              )}
            </div>
          </div>
          {/* <div className="col-6 text-end">
            <h5 className="section-title">BRANCH</h5>
            <div className="info-box">
              <p>
                <strong>Branch:</strong> {request.branchName || "Main Branch"}
              </p>
            </div>
          </div> */}
        </div>

        {/* Services Table */}
        <div className="table-responsive mb-5">
          <table className="table invoice-table">
            <thead>
              <tr>
                <th>Service Description</th>
                <th>Type</th>
                <th className="text-center">Quantity</th>
                <th className="text-end">Price</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>
                  <p className="mb-0 font-weight-bold">
                    {request.service?.name}
                  </p>
                  {/* <small className="text-muted">
                    {request.descraption || "High Quality 3D Printing Service"}
                  </small> */}
                </td>

                <td>{request.service?.type?.name}</td>
                <td className="text-center">1</td>
                <td className="text-end text-primary font-weight-bold">
                  {currency} {totalAmount.toLocaleString()}
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Summary */}
        <div className="row justify-content-end">
          <div className="col-md-5">
            <div className="summary-card p-3">
              <div className="d-flex justify-content-between mb-2">
                <span>Subtotal</span>
                <span>
                  {currency} {totalAmount.toLocaleString()}
                </span>
              </div>
              <div className="d-flex justify-content-between mb-2 text-danger">
                <span>Special Discount</span>
                <span>
                  -{currency} {discount.toLocaleString()}
                </span>
              </div>
              <hr />
              <div className="d-flex justify-content-between total-row">
                <strong>GRAND TOTAL</strong>
                <strong className="text-success">
                  {currency} {finalAmount.toLocaleString()}
                </strong>
              </div>
              {safePaidAmount > 0 && (
                <div className="d-flex justify-content-between mt-2">
                  <strong className="text-muted">Paid Amount</strong>
                  <strong className="text-muted">
                    {currency} {safePaidAmount.toLocaleString()}
                  </strong>
                </div>
              )}
              <div className="d-flex justify-content-between mt-2">
                <strong>Remaining Amount</strong>
                <strong className="text-primary">
                  {currency} {request.remaining_amount?.toLocaleString() || 0}
                </strong>
              </div>
            </div>
          </div>
        </div>

        {/* Footer */}
        <div className="invoice-footer mt-5 pt-4 text-center border-top">
          <p className="thanks">Thank you for choosing QUBX 3D Services!</p>
          {/* <div className="contact-info">
            <span>www.qubx3d.com</span> 
          </div> */}
        </div>
      </div>

      <div className="print-action-bar no-print text-center my-4">
        <button
          className="btn btn-primary btn-print px-5 py-2"
          onClick={handlePrint}
        >
          <i className="fas fa-print me-2"></i> Print Invoice
        </button>
      </div>
    </div>
  );
};

export default Invoice;
